import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Home, AlertTriangle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const funnyMessages = [
  "notFound.funny1",
  "notFound.funny2",
  "notFound.funny3",
  "notFound.funny4",
];

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    supabase.from("page_not_found_logs").insert({
      path: location.pathname + location.search,
      referrer: document.referrer || null,
    }).then(({ error }) => {
      if (error) console.error("Failed to log 404:", error);
    });
  }, [location.pathname, location.search]);

  const randomMessage = funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-pitch px-4">
      <div className="text-center">
        <div className="mb-6 inline-flex items-center justify-center rounded-full bg-white/10 p-5 backdrop-blur-sm">
          <span className="text-6xl">⚽</span>
        </div>

        <h1
          className="mb-2 text-8xl font-bold leading-none tracking-tight text-white"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          404
        </h1>

        <p className="mb-3 text-2xl font-semibold text-white/90">
          {t("notFound.title")}
        </p>

        <p className="mx-auto mb-8 max-w-md text-lg text-white/70">
          {t(randomMessage)}
        </p>

        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Button
            onClick={() => navigate("/")}
            className="gap-2 bg-white text-primary hover:bg-white/90"
          >
            <Home className="h-4 w-4" />
            {t("notFound.backHome")}
          </Button>

          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2 border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white"
          >
            <AlertTriangle className="h-4 w-4" />
            {t("notFound.goBack")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
